// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"d1c13080","97":"284f556e"}[chunkId] + ".chunk.css";
};